import { createContext, useContext } from 'react'

/**
 * Поверх страницы открыто окно тарифов или входа (роут-модал, App). Подсказки-туры страницы ждут его закрытия: иначе
 * они вставали над окном (их слой выше) и затемняли его — владелец 11.10.
 */
export const RouteModalContext = createContext(false)

export function useRouteModalOpen(): boolean {
	return useContext(RouteModalContext)
}
